module.exports = __webpack_public_path__ + "static/normalbrowser-like-b49a22d682702fa3ae4877752dd07229.png";